export enum TournamentType {
    RAPID = 'RAPID',
    POKER = 'POKER',
    LUCKY = 'LUCKY',
}

export const tournamentName = (type: TournamentType) => {
    switch (type) {
        case TournamentType.POKER:
            return 'poker'
        case TournamentType.LUCKY:
            return 'lucky'
        case TournamentType.RAPID:
            return 'flash'
    }
}